export default {
  setEsticoInfo (state, payload) {
    state.total_price = payload.total_price
    state.shipping_amount = payload.shipping_amount
    state.price = payload.price
    state.description = payload.description
    state.slug = payload.intermediary.slug
  },
  LOADER (state, payload) {
    state.loader = !state.loader
  },
  setCustomerInfo (state, payload) {
    state.customer = payload
  },
  setShipping (state, payload) {
    state.shipping = payload
  },
  setCheckoutSession (state, payload) {
    state.checkout = payload
  },
  setGtag (state, payload) {
    state.gtag = payload
  },
  CARDSAVE (state, payload) {
    state.card = payload
  },
  CARDBRAND (state, payload) {
    state.cardBrand = payload
  }

}
